export const CHAIN_ID = {
  Ethereum: 1,
  Arbitrum: 42161,
  Injective: 'injective-1',
  Cosmoshub: 'cosmoshub-4'
}

export const INJECTIVE_DENOMS = {
  INJ: 'inj',
  USDT_PEGGY: 'peggy0xdAC17F958D2ee523a2206206994597C13D831ec7',
  WETH_PEGGY: 'peggy0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  OMNI_PEGGY: 'peggy0x36e66fbbce51e4cd5bd3c62b637eb411b18949d4',
  APP_PEGGY: 'peggy0xC5d27F27F08D1FD1E3EbBAa50b3442e6c0D50439'
}

export const ETH_DENOMS = {
  ETHEREUM_NATIVE: 'ethereum-native',
  USDT: '0xdac17f958d2ee523a2206206994597c13d831ec7',
  INJECTIVE: '0xe28b3B32B6c345A34Ff64674606124Dd5Aceca30',
  WETH: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2'
}

export const COSMOS_DENOMS = {
  UATOM: 'uatom',
  INJ: 'ibc/6469BDA6F62C4F4B8F76629FA1E72A02A3D1DD9E2B22DDB3C3B2296DEAD29AB8'
}

export const ARBITRUM_DENOMS = {
  ARBITRUM_NATIVE: 'arbitrum-native',
  INJ: '0x2A2053cb633CAD465B4A8975eD3d7f09DF608F80',
  WETH: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1'
}

export const denomPriorityMap: Record<string, string[]> = {
  [CHAIN_ID.Injective]: [
    INJECTIVE_DENOMS.INJ,
    INJECTIVE_DENOMS.USDT_PEGGY,
    INJECTIVE_DENOMS.WETH_PEGGY
  ],
  [CHAIN_ID.Ethereum]: [
    ETH_DENOMS.ETHEREUM_NATIVE,
    ETH_DENOMS.INJECTIVE,
    ETH_DENOMS.USDT,
    ETH_DENOMS.WETH
  ],
  [CHAIN_ID.Cosmoshub]: [COSMOS_DENOMS.UATOM, COSMOS_DENOMS.INJ],
  [CHAIN_ID.Arbitrum]: [ARBITRUM_DENOMS.ARBITRUM_NATIVE]
}

export const chainIdPriority = [
  CHAIN_ID.Injective,
  CHAIN_ID.Ethereum,
  CHAIN_ID.Cosmoshub,
  CHAIN_ID.Arbitrum
]

export const tokenPreselectMap: Record<
  string,
  Record<string, Record<string, string>>
> = {
  [CHAIN_ID.Ethereum]: {
    [CHAIN_ID.Injective]: {
      [ETH_DENOMS.ETHEREUM_NATIVE]: INJECTIVE_DENOMS.WETH_PEGGY,
      [ETH_DENOMS.WETH]: INJECTIVE_DENOMS.WETH_PEGGY,
      [ETH_DENOMS.INJECTIVE]: INJECTIVE_DENOMS.INJ,
      [ETH_DENOMS.USDT]: INJECTIVE_DENOMS.USDT_PEGGY
    }
  }
}

function toLowerCaseKeys<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(toLowerCaseKeys) as T
  }

  if (obj !== null && typeof obj === 'object' && !Array.isArray(obj)) {
    const newObj: Record<string, any> = {}
    for (const key of Object.keys(obj)) {
      const newKey = key.toLowerCase()
      const value = (obj as any)[key]
      newObj[newKey] =
        typeof value === 'string' ? value.toLowerCase() : toLowerCaseKeys(value)
    }

    return newObj as T
  }

  if (typeof obj === 'string') {
    return obj.toLowerCase() as T
  }

  return obj
}

export const priorityMap = toLowerCaseKeys(denomPriorityMap)
export const preselectTokenMap = toLowerCaseKeys(tokenPreselectMap)
